
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuLunchSundayHarajukuSundayKunchImage } from "@src/constants/images";
import { meta as theGreatBurgerPageMeta } from "./the_great_burger.mdx";
import { meta as minoringoPageMeta } from "./minoringo.mdx";
export const meta = {
  path: "/media/harajuku/lunch_sunday",
  title: "【【名店厳選】日曜日にランチが食べられる原宿の人気店５選",
  description: "原宿で日曜日でもランチをしている名店を厳選してご紹介します。原宿のランチにおいて、ジャンルのリーダー的存在のお店を、食べログの評価値を基準に厳選しました。今回は、ミシュランに選出される蕎麦のお店、原宿カレーの名店、人気急上昇中のハンガーショップ、原宿駅徒歩4分のパンの名店、そして原宿屈指のパスタの名店の5つをご紹介します。日曜の営業時間、行列情報、人気のランチメニューを掲載しているので、その日のニーズに合わせてお店を選んでみてください。",
  topImg: harajukuLunchSundayHarajukuSundayKunchImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "まとめ記事", "ミシュラン掲載", "ハンバーガー"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿で日曜日でもランチをしている名店を厳選してご紹介します。`}</p>
    <p>{`原宿のランチにおいて、ジャンルのリーダー的存在のお店を、食べログの評価値を基準に厳選しました。`}</p>
    <p>{`今回は、ミシュランに選出される蕎麦のお店、原宿カレーの名店、人気急上昇中のハンガーショップ、原宿駅徒歩 4 分のパンの名店、そして原宿屈指のパスタの名店の 5 つをご紹介します。`}</p>
    <p>{`日曜の営業時間、行列情報、人気のランチメニューを掲載しているので、その日のニーズに合わせてお店を選んでみてください。`}</p>
    <h2>{`【蕎麦】玉笑`}</h2>
    <InstaImage postId="CAWXkDCg9Xe" mdxType="InstaImage" />
    <p>{`原宿で食べログ 4.0 を超えることもある蕎麦の名店は、ミシュランへの掲載実績も多数あり、日本で指折りの蕎麦の名店と言われています。夏の暑い時期には、あっさりした蕎麦が食べたい方も多いのではないかと思いますが、あっさりとした味だけでなく、今までのそばとは一味違うランチの体験をきっと作ってくれると思います。`}</p>
    <h3>{`日曜の営業時間`}</h3>
    <InstaImage postId="CBDpKDhhYG_" mdxType="InstaImage" />
    <p>{`土日祝は予約することはできないうえに、売り切れ次第終了なので、できるだけ早めにお越しいただくことをオススメします。
`}<strong parentName="p">{`開店時間は 11:30`}</strong>{`なので、普段とは違って、早めの日曜ランチとして楽しむのはいかがでしょうか。`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <h4>{`納豆蕎麦`}</h4>
    <InstaImage postId="CBaxlGrD-sW" mdxType="InstaImage" />
    <p>{`大粒の納豆に、卵、薬味、海苔などがトッピングされており、一度にいろんな味が楽しめる玉笑の人気メニュー。
ランチで食べるとボリューム感があるのに、一切胃もたれしない体にも優しいヘルシーな蕎麦になっています。`}</p>
    <h4>{`せいろ蕎麦`}</h4>
    <InstaImage postId="B-ZLYC3gZPx" mdxType="InstaImage" />
    <p>{`卵と薬味、そしてつゆを入れて食べるせいろ蕎麦も玉笑では人気のメニューです。
コシのある太麺に卵の入ったつゆと一緒に食べるメニューは、普段とは一味違ったランチになります。`}</p>
    <ShopInfoBox shopId="brh1uvq23akg00da7npg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【カレー】みのりんご`}</h2>
    <InstaImage postId="B_msNzYAyA9" mdxType="InstaImage" />
    <p>{`原宿駅から徒歩 3 分の好立地に位置するお店は、激戦区の原宿の中でも上位に君臨し続けている名店。
特徴的なみのりんごの名物カレーを求めて、日曜日はランチの時間帯だと行列が並ぶことが多いです。`}</p>
    <h3>{`日曜の営業時間`}</h3>
    <InstaImage postId="B_MOIFbjq73" mdxType="InstaImage" />
    <p>{`年中無休で営業しているみのりんごは、平日だと 14:30 にはランチを終了するのですが、日曜は終日営業しているのでどの時間帯でも安心していくことができます。
しかし、先ほどの玉笑と同じく、売り切れ次第終了なので遅い時間帯の来店は注意が必要です。
日曜の終日営業でも、15 時頃までにはいくことをオススメします。`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <h4>{`とろーりチーズのキーマカレー`}</h4>
    <InstaImage postId="CBXZ06ehkAK" mdxType="InstaImage" />
    <p>{`みのりんご の 1 番人気で定番メニュー！初めてのご来店の方は、一度は食べておきたい名物料理です。`}</p>
    <h4>{`スペアリブで作るポークカレー`}</h4>
    <InstaImage postId="B_3yDutARk_" mdxType="InstaImage" />
    <p>{`辛口のポークカレーは、水を一切使わずに作るヘルシーなカレー。
このメニューを食べた方限定で、激辛のビーフカレーを食べることができるそうなので、2 回目以降の来店の方は是非チャレンジしてみてください！`}</p>
    <LinkWithThumbnail meta={minoringoPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="br5tsra23akg00ac688g" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【バーガー】ザ グレートバーガー`}</h2>
    <InstaImage postId="CA7gkPdBfGF" mdxType="InstaImage" />
    <p>{`原宿のランチで 1 番有名と言われるハンバーガーの名店ザ グレートバーガー。渋谷ストリームに 2 店舗目を出したことでその知名度はさらに向上し、UberEats やテイクアウトも始めたことで、いろんなお客様に知ってもらえる機会が増えています。
食べログの評価が好評価なのはもちろんなこと、百名店への数年連続選出など、その人気の勢いは止まることを知りません。`}</p>
    <h3>{`日曜の営業時間`}</h3>
    <InstaImage postId="CABaz0Eg0Bs" mdxType="InstaImage" />
    <p>{`終日営業のお店で、11:30 から夜の 23 時まで営業しています。なので、遅めのランチになっても空いていることが多いので、日曜日でも嬉しいお店です。
平日は 16 時以降に席の予約ができるのですが、土日祝は予約ができないため、ランチの時間には行列ができていることが多いです。時には、1 時間~2 時間程度並ばないといけない場合もあるので、ランチのピークタイムを外すことをオススメします。`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <h4>{`アボカドモッツァレラバーガー`}</h4>
    <InstaImage postId="CBNFBy-Adnw" mdxType="InstaImage" />
    <p>{`店内、テイクアウト、デリバリーの全てで 1 番人気のランチメニューになります！肉肉しいパテと、アボカドの甘みがマッチングしたメニューで、幅広く受けいられるハンバーガーです。
日曜日のランチで、ガッツリランチをしたい方には、ザ グレートバーガーがオススメです！`}</p>
    <LinkWithThumbnail meta={theGreatBurgerPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brag1o223akg00evu3bg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【パン】レフェクトワール`}</h2>
    <InstaImage postId="B-hdlk2jSTc" mdxType="InstaImage" />
    <p>{`原宿駅から徒歩 4 分の好立地に位置するパン屋の名店で、店内に入るとパンの甘い匂いが充満していて、心がワクワクします。
広いイートインスペースで焼き立てのパンを食べることができ、カウンター席も完備するなど、どんなお客様でも入りやすいお店になっています。`}</p>
    <p>{`食べログの百名店に三年連続で選出され、評価も 3.7 を超える人気店です。`}</p>
    <h3>{`日曜の営業時間`}</h3>
    <InstaImage postId="B8m_QqVpHNe" mdxType="InstaImage" />
    <p>{`平日・土日関わらず、11:00~19:00 の営業なので好きな時間帯にランチができることがレフェクトワールの魅力です。
ランチタイムは行列ができることが多いのですが、テイクアウトのお客様も多く、日曜日でも意外と座ってランチが食べられることが多いそうなので、パンのランチを日曜日にランチで食べたくなった時はぜひチャレンジしてみてください！`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <InstaImage postId="vSaphbyzVh" mdxType="InstaImage" />
    <InstaImage postId="B7lMS6FAGZl" mdxType="InstaImage" />
    <p>{`サラダとドリンクのランチセットが 1,020 円とお得なお値段で食べられ、パンだけでなくマフィンも豊富に取り揃えられているので、その日の気分に合わせてランチをカスタマイズして食べてみるのがオススメです！`}</p>
    <ShopInfoBox shopId="brf4aea23akg00d4drsg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【イタリアン】エミリア`}</h2>
    <InstaImage postId="CA-fw0nD8JW" mdxType="InstaImage" />
    <p>{`原宿・青山・表参道でエリアでイタリアンの名店と言われるエミリアは、隠れ家的なお店でイタリアン好きから愛されているお店。食べログの評価が好評価なのはもちろんだが、手打ちのパスタが人気のお店として知られており、時には行列ができるほどの人気があります。`}</p>
    <h3>{`日曜の営業時間`}</h3>
    <p>{`11:30 ～ 14:30 L.O と比較的に他のお店と比較すると短い時間帯になってしまいますが、席数が 40 席あるため比較的並ぶことも少なく、通常のランチタイムの時間に行っても食べることができるのが嬉しい点です。特に、オープン時や LO 前の時間帯は空いていることが多いので、原宿で用事のある方はショッピングなどのついでランチを食べるのも良いですよね。`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <h4>{`パスタランチセット`}</h4>
    <InstaImage postId="BtQoNUGgzGb" mdxType="InstaImage" />
    <p>{`お好きなパスタが選べるパスタランチセットがオススメです！1 番人気の手打ちのパスタのランチセットがあるだけでなく、その中でも好きなパスタを選べるというのがエミリアのランチの魅力です。
好きな飲み物と前菜がついて、値段は 1,400 円とリーズナブルなので、原宿で日曜日に美味しいパスタランチ食べたい時には、エミリアがオススメです！`}</p>
    <ShopInfoBox shopId="brh20ka23akg00da7nv0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`原宿で日曜日にランチが食べられる名店を厳選してご紹介してきましたが、いかがでしたでしょうか。ミシュランに選ばれる店から、終日営業をしていて比較的どの時間帯でもランチが食べやすいお店など、行列情報も併せてお届けしました。日曜日に原宿で名店のランチを食べたいと思った時には、ぜひこちらの記事を参考にして素敵なランチタイムを過ごしてください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;